import React from "react"
import { ImageContainer, HeadingOne } from "../elements"
import {
  headerHeight,
  headerHeightMd,
  headerHeightLg,
  breakpointMedium,
  breakpointLarge,
  textColorLight,
} from "../variables"
import styled from "styled-components"

const HeroSection = ({ slice }) => {
  const url = slice.primary.hero_image.localFile.childImageSharp.fluid
  const alt = slice.primary.hero_image.alt

  const { hero_text, center_title } = slice.primary

  return (
    <HeroContainer>
      <ImageContainer alt={alt} fluid={url} objectFit="cover" height="100%" />
      {hero_text && (
        <HeroHeading
          center_title={center_title}
          color={textColorLight}
          fontSizeMd="80px"
        >
          {hero_text.text}
        </HeroHeading>
      )}
    </HeroContainer>
  )
}

export default HeroSection

const HeroHeading = styled(HeadingOne)`
  text-align: center;
  font-weight: normal;
  position: relative;
  top: 10%;

  @media (min-width: ${breakpointLarge}) {
    position: ${({ center_title }) =>
      center_title === "true" ? "static" : "absolute"};
    top: 30%;
    right: 25%;
    padding: ${({ center_title }) =>
      center_title === "true" ? "66px 0 0 0" : 0};
    text-align: ${({ center_title }) => center_title === "true" && "center"};
    width: ${({ center_title }) =>
      center_title === "true" ? "100%" : "300px"};
  }
`

const HeroContainer = styled.section`
  height: ${`calc(375px - ${headerHeight})`};
  width: 100%;
  position: relative;

  ${ImageContainer} {
    position: absolute !important;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    left: 0;
  }

  @media (min-width: ${breakpointMedium}) {
    height: ${`calc(541px - ${headerHeightMd})`};
  }

  @media (min-width: ${breakpointLarge}) {
    height: ${`calc(680px - ${headerHeightLg})`};
  }
`
